<div class="numpad-host-wrapper" [@slideInOut]="opened ? 'in' : 'out'">
    <ms-numpad-error *ngIf="error" [error]="error" />
    <ng-template #numpadhost class="numpadhost" />
</div>
